import {
  ADD_CLIENT_PROFILE_TABS,
  SET_CLIENT_PROFILE_TABS_LOADING,
} from "../Actions/types";

const initialState = {
  loading: true,
  availableTabs: null,
};

const clientProfileTabsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLIENT_PROFILE_TABS_LOADING:
      return { ...state, loading: action.payload };
    case ADD_CLIENT_PROFILE_TABS:
      return { ...state, availableTabs: action.payload };

    default:
      return state;
  }
};

export default clientProfileTabsReducer;
